<template>
    <div>

        <vue-headful title="Training Courses :: MeritEHS"/>

        <h4 class="py-2 mb-2">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-graduation-cap"></i> Training Courses</li>
                <li class="ml-3 d-none d-md-inline-block" v-if="this.$root.hasPermission(['training_courses.manage'])">
                    <router-link :to="`/training-courses/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
                    <router-link :to="`/training-courses/import`" class="btn btn-sm btn-primary"><i class="fa fa-file-excel-o"></i> Import</router-link>
                </li>
            </ol>
        </h4>

        <div class="d-block d-md-none mt-3 mb-3" v-if="this.$root.hasPermission(['training_courses.manage'])">
            <router-link :to="`/training-courses/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
            <router-link :to="`/training-courses/import`" class="btn btn-sm btn-primary"><i class="fa fa-file-excel-o"></i> Import</router-link>
        </div>

        <div class="card">
            <div class="card-body">
                <training-course-list ref="trainingCourseIndexList"></training-course-list>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },

        mounted(){
            //Focus
            this.$refs.trainingCourseIndexList.$refs.trainingCourseTable.$refs.genericFilter.focus();
        },
    }
</script>
